<template>
  <v-container>
    <v-row>
      <v-col>
        <TaskDocumentationForm
            ref="taskDocument"
            hide-button
            @closeDialog="() => {$emit('dialogClosed')}"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import TaskDocumentationForm from '@/modules/book/views/task/components/TaskDocumentationForm.vue';

export default {
  name: 'CreateTaskStep',
  components: {TaskDocumentationForm},
  data() {
    return {
      inputData: {}
    }
  },
  methods: {
    setInputData(inputData) {
      this.inputData = inputData;
      this.$refs.taskDocument.setInputData(inputData);
    },
    save() {
      this.$refs.taskDocument.save();
    },
    cancelDialog() {
      this.$refs.taskDocument.clearForm();
      this.inputData = {}
    }
  }
}
</script>